import { render, staticRenderFns } from "./LocationSearchComponent.vue?vue&type=template&id=b4f5a1e8"
import script from "./LocationSearchComponent.vue?vue&type=script&lang=js"
export * from "./LocationSearchComponent.vue?vue&type=script&lang=js"
import style0 from "./LocationSearchComponent.vue?vue&type=style&index=0&id=b4f5a1e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports